import { RespondentProgress } from './respondentProgress'

export enum EntryType {
  MatrixEntryType = 'MatrixEntryType',
  QuestionEntryType = 'QuestionEntryType',
  TextCardEntryType = 'TextCardEntryType',
  TermsEntryType = 'TermsEntryType',
  TextHighlighterEntryType = 'TextHighlighterEntryType',
  ConjointEntryType = 'ConjointEntryType'
}

export type SelectedResponses = {
  [rowPosition: number]: [
    {
      responseDateTime: string
      responseOptionId: string
    }
  ]
}

export enum ResponseChoiceValue {
  Selected = 'Selected',
  NotSelected = 'NotSelected'
}

export enum PanelSupplierCode {
  Cint = 'cint',
  Prolific = 'prolific',
  Fd = 'fd',
  PureSpectrum = 'purespectrum',
  CintExchange = 'cintexchange'
}

export function getPureSpectrumStatusCode(
  progress: RespondentProgress | undefined
): string {
  if (progress?.isCompleted) {
    return process.env.REACT_APP_PURESPECTRUM_COMPLETE_CODE as string
  }
  if (progress?.isQuotaFull) {
    return process.env.REACT_APP_PURESPECTRUM_QUOTA_FULL_CODE as string
  }
  if (progress?.isScreened) {
    return process.env.REACT_APP_PURESPECTRUM_SCREEN_OUT_CODE as string
  }
  if (progress?.isQualityTerminated) {
    return process.env.REACT_APP_PURESPECTRUM_QUALITY_TERMINATE_CODE as string
  }
  return process.env.REACT_APP_PURESPECTRUM_COMPLETED_CODE as string
}

export function getCintExchangeRedirectionURL(
  respondentProgress: RespondentProgress | undefined
): string {
  if (respondentProgress?.isQuotaFull) {
    return `${process.env.REACT_APP_CINT_EXCHANGE_QUOTA_FULL_REDIRECT_URL}RID=${respondentProgress?.respondentId}`
  }
  if (respondentProgress?.isScreened) {
    return `${process.env.REACT_APP_CINT_EXCHANGE_SCREENOUT_REDIRECT_URL}RID=${respondentProgress?.respondentId}`
  }
  if (respondentProgress?.isQualityTerminated) {
    return `${process.env.REACT_APP_CINT_EXCHANGE_QUALITY_TERMINATE_REDIRECT_URL}RID=${respondentProgress?.respondentId}`
  }
  return `${process.env.REACT_APP_CINT_EXCHANGE_COMPLETE_REDIRECT_URL}RID=${respondentProgress?.respondentId}`
}
